var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.07 3.258C0 3.626 0 4.068 0 4.95V12c0 3.771 0 5.657 1.172 6.828C2.343 20 4.229 20 8 20h4c3.771 0 5.657 0 6.828-1.172C20 17.657 20 15.771 20 12V9.798c0-2.632 0-3.949-.77-4.804a2.981 2.981 0 0 0-.224-.225C18.151 4 16.834 4 14.202 4h-.374c-1.153 0-1.73 0-2.268-.153a4 4 0 0 1-.848-.352C10.224 3.224 9.816 2.815 9 2l-.55-.55a8.804 8.804 0 0 0-.554-.53 4 4 0 0 0-2.18-.903C5.53 0 5.336 0 4.95 0c-.883 0-1.324 0-1.692.07A4 4 0 0 0 .07 3.258ZM14.282 1c.366 0 .55 0 .703.02 1.018.14 1.828.943 2.014 1.98a4.803 4.803 0 0 0-.461-.081c-.64-.084-1.448-.084-2.45-.084h-.334c-.942 0-1.3-.005-1.625-.101a2.512 2.512 0 0 1-.542-.233c-.296-.17-.552-.428-1.218-1.118L10 1h4.284-.002ZM11 7.25a.75.75 0 1 0 0 1.5h5a.75.75 0 1 0 0-1.5h-5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSolid);
export default __webpack_public_path__ + "static/media/folder-solid.c74dae45352ea4d30dbc68ca778cf8d6.svg";
export { ForwardRef as ReactComponent };